import React from 'react';
import classNames from 'classnames';
import { Field, useFormState } from 'react-final-form';
import {
  OptionType,
  QARoleSelectOption,
} from 'components/QaRolesCustomSelect/QaRolesCustomSelect.component';
import SelectCustomOptionsField from 'components/SelectCustomOptionsField';
import { useTranslation } from 'react-i18next';
import validations from 'validations';

type QaRolesCustomSelectFieldProps = {
  className?: string;
  renderAsPortal?: boolean;
  portalClassName?: string;
  options: OptionType[];
  name: string;
  label: string;
  required?: boolean;
};

const QaRolesCustomSelectField: React.FC<QaRolesCustomSelectFieldProps> = (
  props,
) => {
  const {
    className,
    renderAsPortal,
    portalClassName,
    options,
    name,
    label,
    required = true,
  } = props;
  const { t } = useTranslation();
  const { values } = useFormState();

  const classes = classNames('qa-roles-custom-select-field', className);

  return (
    <Field
      className={classes}
      name={name}
      label={label}
      options={options.map(({ value, props }) => ({
        value,
        renderedOption: <QARoleSelectOption {...props} />,
      }))}
      renderedTrigger={
        values[name] ? (
          <span>
            {options.find((opt) => opt.value === values[name])?.props.title}
          </span>
        ) : (
          t('chooseRole')
        )
      }
      renderAsPortal={renderAsPortal}
      portalClassName={portalClassName}
      component={SelectCustomOptionsField}
      {...(required && {
        required,
        validate: validations.required(),
      })}
    />
  );
};

export default QaRolesCustomSelectField;
